/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../bills/bill';
import '../../common/token';
import '../../bills/cart';
import '../../giftcard/model/giftcard';
import '../../bills/tender';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "v3": {
            "nested": {
              "EventType": {
                "values": {
                  "PAYMENT": 0,
                  "REFUND": 1,
                  "REFUND_V3": 2,
                  "PAYMENT_EXCHANGE": 3,
                  "REFUND_EXCHANGE": 4
                }
              },
              "BillWithRelatedTokens": {
                "fields": {
                  "originalBill": {
                    "type": "squareup.bills.Bill",
                    "id": 1,
                    "rule": "optional"
                  },
                  "relatedBillToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ResidualBill": {
                "fields": {
                  "residualItemization": {
                    "type": "squareup.beemo.v3.ResidualBill.ResidualItemization",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "residualItemizationGroup": {
                    "type": "squareup.beemo.v3.ResidualBill.ResidualItemizationGroup",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "residualTender": {
                    "type": "squareup.beemo.v3.ResidualBill.ResidualTender",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "residualTip": {
                    "type": "squareup.beemo.v3.ResidualBill.ResidualTip",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "canOnlyIssueAmountBasedRefund": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "residualSurcharge": {
                    "type": "squareup.beemo.v3.ResidualBill.ResidualSurcharge",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "includesMultiSourceBills": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "amendmentToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ResidualItemization": {
                    "fields": {
                      "sourceBillTokenPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sourceItemizationTokenPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 2,
                        "rule": "optional"
                      },
                      "itemization": {
                        "type": "squareup.bills.Itemization",
                        "id": 3,
                        "rule": "optional"
                      },
                      "sourceItemizationQuantity": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "giftCard": {
                        "type": "squareup.giftcard.model.GiftCard",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "ResidualItemizationGroup": {
                    "fields": {
                      "sourceBillTokenPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sourceItemizationGroupTokenPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 2,
                        "rule": "optional"
                      },
                      "itemizationGroup": {
                        "type": "squareup.bills.ItemizationGroup",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ResidualTender": {
                    "fields": {
                      "sourceBillTokenPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sourceTenderServerToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "tender": {
                        "type": "squareup.bills.Tender",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ResidualTip": {
                    "fields": {
                      "sourceBillTokenPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 1,
                        "rule": "optional"
                      },
                      "residualTip": {
                        "type": "squareup.bills.TipLineItem",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ResidualSurcharge": {
                    "fields": {
                      "sourceBillTokenPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 1,
                        "rule": "optional"
                      },
                      "residualSurcharge": {
                        "type": "squareup.bills.SurchargeLineItem",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.v3?.nested?.EventType && !$root.nested?.squareup?.nested?.beemo?.nested?.v3?.nested?.BillWithRelatedTokens && !$root.nested?.squareup?.nested?.beemo?.nested?.v3?.nested?.ResidualBill && !$root.nested?.squareup?.nested?.beemo?.nested?.v3?.nested?.ResidualBill?.nested?.ResidualItemization && !$root.nested?.squareup?.nested?.beemo?.nested?.v3?.nested?.ResidualBill?.nested?.ResidualItemizationGroup && !$root.nested?.squareup?.nested?.beemo?.nested?.v3?.nested?.ResidualBill?.nested?.ResidualTender && !$root.nested?.squareup?.nested?.beemo?.nested?.v3?.nested?.ResidualBill?.nested?.ResidualTip && !$root.nested?.squareup?.nested?.beemo?.nested?.v3?.nested?.ResidualBill?.nested?.ResidualSurcharge) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE EventType @ squareup/beemo/v3/bill.proto at 44:1
 */
export const EventType = $root.lookupEnum('squareup.beemo.v3.EventType').values;
/**
 * SOURCE BillWithRelatedTokens @ squareup/beemo/v3/bill.proto at 223:1
 */
export const BillWithRelatedTokens = $root.lookupType('squareup.beemo.v3.BillWithRelatedTokens');
fixType(BillWithRelatedTokens);
Builder.createAndAttachToType(BillWithRelatedTokens);
/**
 * Represents an aggregated view of a bill family by combining all sales, refunds, exchanges, and tenders.
 *
 * This can be used to determine which items can still be refunded or exchanged,
 * and which tenders have remaining charge that can be refunded.
 *
 * SOURCE ResidualBill @ squareup/beemo/v3/bill.proto at 259:1
 */
export const ResidualBill = $root.lookupType('squareup.beemo.v3.ResidualBill');
fixType(ResidualBill);
Builder.createAndAttachToType(ResidualBill);
/**
 * next id: 9
 * Aggregated items, accounted for exchanges and refunds
 *
 * SOURCE ResidualItemization @ squareup/beemo/v3/bill.proto at 263:3
 */
ResidualBill.ResidualItemization = $root.lookupType('squareup.beemo.v3.ResidualBill.ResidualItemization');
fixType(ResidualBill.ResidualItemization);
Builder.createAndAttachToType(ResidualBill.ResidualItemization);
/**
 * Aggregated itemization groups
 *
 * SOURCE ResidualItemizationGroup @ squareup/beemo/v3/bill.proto at 278:3
 */
ResidualBill.ResidualItemizationGroup = $root.lookupType('squareup.beemo.v3.ResidualBill.ResidualItemizationGroup');
fixType(ResidualBill.ResidualItemizationGroup);
Builder.createAndAttachToType(ResidualBill.ResidualItemizationGroup);
/**
 * Aggregated tenders, accounted for exchanges and refunds
 *
 * SOURCE ResidualTender @ squareup/beemo/v3/bill.proto at 288:3
 */
ResidualBill.ResidualTender = $root.lookupType('squareup.beemo.v3.ResidualBill.ResidualTender');
fixType(ResidualBill.ResidualTender);
Builder.createAndAttachToType(ResidualBill.ResidualTender);
/**
 * SOURCE ResidualTip @ squareup/beemo/v3/bill.proto at 297:3
 */
ResidualBill.ResidualTip = $root.lookupType('squareup.beemo.v3.ResidualBill.ResidualTip');
fixType(ResidualBill.ResidualTip);
Builder.createAndAttachToType(ResidualBill.ResidualTip);
/**
 * SOURCE ResidualSurcharge @ squareup/beemo/v3/bill.proto at 306:3
 */
ResidualBill.ResidualSurcharge = $root.lookupType('squareup.beemo.v3.ResidualBill.ResidualSurcharge');
fixType(ResidualBill.ResidualSurcharge);
Builder.createAndAttachToType(ResidualBill.ResidualSurcharge);